module.exports = "<ng-transclude class=\"<%= gwSummaryInfoRow %>\"></ng-transclude>"